import { $qs, $qsa } from '../../utils/QuerySelector';
import Swiper, { Navigation } from 'swiper';

function slider(block) {
    const swiper = new Swiper(block, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 28,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: function(){
                let currentSlide = this.realIndex + 1;
                $qs('[data-target="team-slider-current-slide"]', this.el).innerHTML = currentSlide;
            },
        },
        breakpoints: {
            824: {
                slidesPerView: 2,
                spaceBetween: 28,
            },
            // 1080: {
            //     slidesPerView: 3,
            // },
            1302: {
                slidesPerView: 2,
                spaceBetween: 65,
            }
        }
    });
}

function videosSlider() {
    const blocks = $qsa('[data-target="videos-slider"]');

    if (!blocks) return;
    
    blocks.forEach(block => {
        slider(block);
    });
}

export default videosSlider;